/* eslint-disable no-lone-blocks */
import React, {useState, useEffect} from "react";
import { Bar } from "react-chartjs-2";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

const RegisteredMemberChart = () => {
  const [member, setMember] = useState([]);
  const { access } = useSelector(state => state.authSlice.userInfo);
  const [refreshing, setRefreshing]=useState(false)

  const getMemberData = async() => {
    try {
      const result = await fetchApi.get('members-graph/', {
        headers: {
          'Authorization': `Bearer ${access}`,
        },
      });
    
      if (result.status === 200) {
        const memberDataResponse = result.data;
        console.log('memberDataResponse', result.data);
        const monthlyRegister = {};
        const currentYear = new Date().getFullYear();
    
        memberDataResponse.forEach((register) => {
          const createdDate = new Date(register.created_at);
          const registerYear = createdDate.getFullYear();
    
          if (registerYear === currentYear) {
            const month = createdDate.toLocaleString('en-US', { month: 'long' });
    
            if (monthlyRegister[month]) {
              monthlyRegister[month]++; // Increment the count for the month
            } else {
              monthlyRegister[month] = 1; // Initialize count to 1 for the month
            }
          }
        });
    
        const allMonths = Array.from({ length: 12 }, (_, i) => {
          const monthName = new Date(currentYear, i).toLocaleString('en-US', {
            month: 'long',
          });
          return {
            month: monthName,
            totalRegisrer: monthlyRegister[monthName] || 0,
          };
        });
    
        setMember(allMonths);
      }
    } catch (error) {
      console.log({ error });
    }
    
  }

  useEffect(()=>{
    getMemberData();
  },[])

  async function handleRefresh(params) {
    setRefreshing(true)
    await getMemberData()
    setRefreshing(false)
  }

  const currentDate = new Date()
	const currentMonth = currentDate.getMonth() + 1
  const data = {
    labels: member.slice(0, currentMonth)?.map((label) => label?.month),
    datasets: [
      {
        label: "Member Registered",
        data: member.slice
              (0, currentMonth)
              ?.map((label) => label?.totalRegisrer),
        backgroundColor: "#ffbe70",
        borderWidth: 0,
      },
    ],
  };

  const options = {
    scales: {
      type: 'category',
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,        
          usePointStyle: false,
          boxHeight: 15,   
          padding: 10,
          color: "#000",
          font: { 
            size: 14, 
            weight: "500",
            family:'roboto'       
          },
        },
      },
      
    },
  };

  return (
    <div className=' w-full bg-white sm:p-5 p-2.5 rounded-xl shadow md:mt-6 mt-4'>
    <div className='dashboardCard'>
      <div className='flex items-center justify-between gap-2'>
      <p style={{color:'black', fontSize:'20px'}}>
        Registered Members
        </p>
        <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
      </div>
      <Link to='/memberdetailpage'>   
    <div className="family-registration-chart dashboard-responsive" style={{height:'-webkit-fill-available'}}>
      <Bar data={data} options={options}  height={430}/>
    </div>
    </Link>
    </div>
    </div>
  );
};

export default RegisteredMemberChart;
